import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentForm from '../components/ContentForm/ContentForm';
import { actions } from '../redux/contentActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class ContentFormContainer extends Component {
  static propTypes = {
    resource: PropTypes.object,
  };

  handleSubmit(resource) {
    const { actions } = this.props;
    if (resource.data.id) {
      return actions.updateContent(resource);
    }

    return actions.createContent(resource);
  }

  render() {
    return (
      <ContentForm onSubmit={(values) => this.handleSubmit(values)} {...this.props} />
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(ContentFormContainer);
